module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_6000.312937e9.png";